import { Offcanvas, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { OrganizationInterface } from "./Organization";
import { useForm } from "react-hook-form";
import { Tab, Tabs } from "react-bootstrap";
import CompanyLogo from "../../assets/user.png"
import Transaction from "./Transaction";
import TeamMember from "./TeamMember";
import Resources from "./Resources";
import Subscription from "./Subscription";

interface PropData {
    show: boolean
    handleClose: () => void
    data: OrganizationInterface | null
}
const ViewOrganization = (props: PropData) => {
    const { register, handleSubmit, formState: { errors }, reset, setValue, watch, } = useForm<OrganizationInterface>();
    const [isLoading, setLoading] = useState(false);
    const [bladeTitle, setBladeTitle] = useState("");
    const [selectedUser, setSelectedUser] = useState<OrganizationInterface | null>(null);
    const [currentTab, setCurrentTab] = useState("InventoryIns");

    useEffect(() => {
        if (props.data) {
            setBladeTitle('Organization Details')
            reset(props.data)
            setSelectedUser(props.data)
        } else {
            reset({})
            setBladeTitle('Add Organization')
        }
    }, [props.show])

    const getCurrentKey = (value: any) => {
        setCurrentTab(value);
    };
    const handleClose = props.handleClose;
    const show = props.show;
    const data = props.data;

    const onCloseModal = (e?: any) => {
        reset({})
        handleClose()
    }

    return (
        <>
            <Offcanvas
                show={show}
                onHide={() => { reset(); onCloseModal(); }}
                placement="end"
                className="offcanvas-custom"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{bladeTitle}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="col-lg-12 bg-white rounded-2">
                        <div className="d-flex justify-content-end"></div>
                        <div className="custom-tabs">
                            <Tabs defaultActiveKey="serviceMaster" onSelect={getCurrentKey}>
                                <Tab eventKey="serviceMaster" title={<span>Information (Details)</span>}>
                                    <div className="p-2 h-100">
                                        <div className="card shadow-sm h-100">
                                            <div className="card-body">
                                                {/* Logo Image */}
                                                {/* <div className="mb-4 w-100 d-flex justify-content-center">
                                                    <img
                                                        src={data?.logo ? data.logo : CompanyLogo}
                                                        style={{ width: 100, height: 100, objectFit: "cover", borderRadius: "50%", border: "1px solid #ddd", background: "#f8f9fa" }}
                                                    />
                                                </div> */}
                                                {/* Details */}
                                                <div className="w-100">
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Company Name:</strong>
                                                            <span className="text-dark">{data?.name || "-"}</span>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Office Email:</strong>
                                                            <span className="text-dark">{data?.email || "-"}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Office Phone:</strong>
                                                            <span className="text-dark">{data?.phone || "-"}</span>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Website:</strong>
                                                            <span className="text-dark">{data?.website || "-"}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Category:</strong>
                                                            <span className="text-dark">{typeof data?.category === "object" && data?.category !== null ? (data.category as { name?: string }).name : data?.category}</span>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">GST Number:</strong>
                                                            <span className="text-dark">{data?.gstNumber || "-"}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Address:</strong>
                                                            <span className="text-dark">{data?.address || "-"}</span>
                                                        </div>

                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Country:</strong>
                                                            <span className="text-dark">
                                                                {typeof data?.country === "object" && data?.country !== null
                                                                    ? (data.country as { name?: string }).name
                                                                    : data?.country || "-"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">State:</strong>
                                                            <span className="text-dark">
                                                                {typeof data?.state === "object" && data?.state !== null
                                                                    ? (data.state as { name?: string }).name
                                                                    : data?.state || "-"}
                                                            </span>
                                                        </div>

                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">City:</strong>
                                                            <span className="text-dark">
                                                                {typeof data?.city === "object" && data?.city !== null
                                                                    ? (data.city as { name?: string }).name
                                                                    : data?.city || "-"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Pin Code:</strong>
                                                            <span className="text-dark">{data?.pinCode || "-"}</span>
                                                        </div>
                                                    </div>                                                    
                                                    {/* <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Status:</strong>
                                                            <span className={`badge ${data?.status === 'ACTIVE' ? 'bg-success' : 'bg-secondary'}`}>
                                                                {data?.status || "-"}
                                                            </span>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Type:</strong>
                                                            <span className="text-dark">{data?.type || "-"}</span>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Tab>

                                <Tab
                                    eventKey="subscription"
                                    title={<span>Membership</span>}
                                >
                                    <div className="p-2 h-100">
                                        <Subscription data={selectedUser} />
                                    </div>
                                </Tab>

                                <Tab
                                    eventKey="teamMembers"
                                    title={<span>Team Members</span>}
                                >
                                    <div className="p-2 h-100">
                                        <TeamMember data={selectedUser} />
                                    </div>
                                </Tab>

                                <Tab
                                    eventKey="transactions"
                                    title={<span>Transactions</span>}

                                >
                                    <div className="p-2 h-100">
                                        <Transaction data={selectedUser} />
                                    </div>

                                </Tab>



                                <Tab
                                    eventKey="resources"
                                    title={<span>Resources</span>}
                                >
                                    <div className="p-2 h-100">
                                        <Resources data={selectedUser} />
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>

    );
};

export default ViewOrganization;
